<template>
  <div>
   <!-- Cabeçalho -->
   <section class="pt-28 2xl:pt-36 pb-12 text-center bg-oxford-blue">
      <h1 class="text-3xl md:text-5xl text-white font-bold mb-10">
        {{ translate('Find the right company','ucfirst')}} <br />
        {{ translate('to work','ucfirst')}}
      </h1>
    </section>

    <!-- Formulários de pesquisa -->
    <section class="hidden w-3/4 mx-auto bg-white rounded-lg shadow-md py-4 px-3 md:-mt-10 ">
      <form @submit.prevent="searchOffers" class="flex flex-col md:flex-row ">
        <InputGroup class="w-full">
          <InputGroupAddon>
            <i class="pi pi-search"></i>
          </InputGroupAddon>
          <InputText
            placeholder="Área de atuação"
            class="w-full outline-none py-2 px-3"
          />
        </InputGroup>
        <InputGroup class="w-full">
          <InputGroupAddon>
            <i class="pi pi-map"></i>
          </InputGroupAddon>
          <InputText placeholder="Localização" class="w-full outline-none py-2 px-3" />
        </InputGroup>
        <InputGroup class="w-full">
          <InputGroupAddon>
            <i class="pi pi-sort-alpha-up"></i>
          </InputGroupAddon>
          <MultiSelect
            v-model="selectedCategories"
            :options="groupedCategories"
            optionLabel="name"
            :maxSelectedLabels="4"
            placeholder="Todas categorias"
            class="w-full outline-none"
          >
          </MultiSelect>
        </InputGroup>
        <Button
          type="submit"
          label="Buscar"
          class="ml-3 py-1 pl-3 pr-12 text-white rounded-md bg-sea-serpent"
        />
      </form>
    </section>

    <!-- seção principal -->
    <section class="flex py-20 md:pl-6 relative">
      <!-- Barra lateral de filtros  -->
      <FiltersSidebarCompanies
        @filters="filtersTypes" class="hidden"
      />

      <section class="w-full px-4 lg:px-6">
        <div class="w-full flex flex-col md:flex-row md:justify-between md:items-center space-y-3 md:space-y-0 px-5 mb-6 lg:mb-8">
          <p class="text-lg">
            {{ translate('Mostrando','ucfirst') }} 
            <strong v-if="!props.isLoading">
              {{ JSON.stringify(props.companyData.data) != '{}' ? props.companyData.data.data.length : '0' }}
            </strong>  
            {{ translate('resultados','ucfirst') }} 
          </p>
          <span v-if="!props.isLoading">
            {{ translate('Organizar por','ucfirst') }}: 
            <Dropdown 
              v-model="selectedSort"
              :options="sort"
              optionLabel="name"
              :disabled="JSON.stringify(props.companyData.data) == '{}' ? true: true" 
              :placeholder="translate('selecionar','ucfirst')"
              class="w-full md:w-44" 
            />
          </span>
        </div>

        <!-- Listagem empresas -->
        <div class="flex flex-wrap justify-center gap-4 p-4"> 
          <LoadingComponent v-if="props.isLoading" class="lg:mt-20" />
         
          <div v-else-if="!props.isLoading && !props.companyData.success" class="w-full text-center lg:mt-32">
            <h1 class="text-lg font-semibold">
              {{ translate('Ops! Houve um problema, actualize a página','ucfirst') }}
            </h1>
          </div>
         
          <div v-else class="w-full flex flex-wrap justify-start gap-4 gap-y-6"> 
            <h1 v-if="JSON.stringify(props.companyData.data.data) == '{}'" class="text-center text-lg font-semibold lg:mt-32">
              {{ translate('Ops! Nenhum resultado foi encontrado','ucfirst') }}
            </h1>
            <CompanyCard v-else :company-list="companyData.data.data" />
          </div>
          
        </div>

        <!-- Paginação -->
        <div class="w-full mt-9">
          <Pagination :pagination='{}' />
        </div>

      </section>

    </section>
    
  </div>
</template>

<script setup>
import { ref, reactive } from "vue"; 
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import MultiSelect from "primevue/multiselect";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Pagination from "@/components/Base/Pagination.vue";
import FiltersSidebarCompanies from "@/components/Filters/SidebarCompanies.vue";
import LoadingComponent from "@/components/Utils/LoaderComponent.vue";
import CompanyCard from "@/components/Company/CompanyCard.vue";
import { translate } from "@/composables/translate";  

 
const props = defineProps({
    companyData: {
            type: Object,
            required: true
        },
    isLoading: {
      type: Boolean,
      required: false,
      default: true
    } 
  });


const selectedCategories = reactive([]);
const groupedCategories = reactive([
  { name: "Tecnologia", id: "tn" },
  { name: "Saúde", id: "su" },
  { name: "Marketing Digital", id: "md" },
  { name: "Construção", id: "ct" },
  { name: "Gestão", id: "gt" },
  { name: "Esporte", id: "ep" },
]);

const selectedSort = ref("Mais recente");
const sort = ref([
  { name: "Mais recente", code: "mr" },
  { name: "Mais Antigo", code: "ma" },
  { name: "Salãrio Alto", code: "sa" },
  { name: "Salário Baixo", code: "sb" },
]);

function filtersTypes(){
   
    // emit("filters", selected);
}


</script>

<style scoped></style>